const schedule = process.env.REACT_APP_HOST_API_SCHEDULE;
export default schedule;
